import React from 'react';



import LocalizedStrings from 'react-localization';



class Localization extends React.Component {

  static strings = new LocalizedStrings({

    en:{

      ACCEPT : 'Accept',
      ACCOUNT_SETTINGS : 'Account Settings',
      ADD_CONTENT : 'Add Content',
      ADD_MIND_MAP_FILL_IN_BOX : 'Add Fillable Box',
      ADD_MIND_MAP_LABLE_BOX : 'Add Labelling Box',
      ADMIN_TASK : 'Admin Task',
      ALL_SCHOOLS : 'All Schools',
      ALL_USERS : 'All Users',
      ANSWER : 'Answer',
      ANSWER_NOT_ALL_FILLED : 'Please provide at least 4 files for the answers',
      ARCHIVE:'Download to Excel',
      AUTHOR : 'Author',
      BACK : 'Back',
      CANCEL : 'Cancel',
      CATEGORY : 'Category',
      CATEGORY_CREATION : 'Creation',
      CATEGORY_EXPERIENCE : 'Experience',
      CATEGORY_EXPERIMENT : 'Experiment',
      CATEGORY_EXPLORATION : 'Exploration',
      CATEGORY_NONE : 'None',
      CATEGORY_KNOWLEDGE : 'Knowledge',
      CHANGE : 'Change',
      CHANGE_PASSWORD : 'Change Password',
      CHOICE : 'Choice',
      CLEAR : 'Clear',
      CLOSE : 'Close',
      COLOR : 'Color',
      COLUMN : 'Column',
      COMPARE_ANSWERS : 'Compare Answers',
      CONTENT : 'Content',
      CONTENT_NAME : 'Content Name',
      CONTENT_PHOTO_FILE_INSTRUCTION : 'If you would like to describe more than 1 photo, you may create multiple photo descriptions. \n Photo is not necessary but recommended to enhance learning motivation. \n The maximum characters for each photo description is 2000.',
      CONTENT_TYPE : 'Content Type',
      CONTINUE_EDITING : 'Continue Editing',
      CORRECT : 'Correct',
      CORRECT_ANSWER : 'Correct Answer',
      CORRECT_ANSWER_CONTECT_NOT_FILLED : 'Please fill in the correct answers',
      CORRECT_ANSWER_NOT_SELECTED : 'Please select at least one correct answer(s)',
      COVER_IMAGE : 'Cover Image',
      CREATE : 'Create',
      CREATE_SCHOOL : 'Create School',
      CREATE_USER : 'Create User',
      CREATED : 'Created',
      DARK_MODE : 'Dark Mode',
      DECLINE : 'Decline',
      DELETE : 'Delete',
      DELETE_CONTENT : 'Delete Content',
      DELETE_FAILED : 'Delete Failed',
      DELETE_FILE : 'Delete File',
      DELETE_HOTSPOT : 'Delete Hotspot',
      DELETE_LOCALE : 'Delete LOCALE',
      DELETE_MIND_MAP_BOX : 'Delete Box',
      DELETE_MIND_MAP_LINK : 'Delete Link',
      DELETE_REMINDER : 'Files cannot be recovered after deletion, are you sure you want to delete the selected item?',
      DELETED : 'Deleted',
      DESCRIPTION : 'Description',
      DESCRIPTION_AUDIO : 'Description of Audio',
      DESCRIPTION_FILL_IN_THE_BLANK_AFTER : 'Description after Fill-in-the-Blank',
      DESCRIPTION_FILL_IN_THE_BLANK_BEFORE : 'Description before Fill-in-the-Blank',
      DESCRIPTION_IMAGE : 'Description of Image',
      DESCRIPTION_NOT_FILLED : 'Please fill in the description',
      DESCRIPTION_QUESTION : 'Question',
      DESCRIPTION_TAKE_PHOTO : 'Question / description for taking a photo',
      DESCRIPTION_TAKE_RECORD : 'Question / description for voice recording',
      DESCRIPTION_TEXT : 'Description of Text',
      DESCRIPTION_VIDEO : 'Description of Video',
      DETAILS : 'Details',
      DIFFICULTY : 'Difficulty',
      DISCARD : 'Discard',
      DISCARD_CHANGES : 'Discard Changes',
      DISPLAY_NAME : 'Display Name',
      DISPLAY_NAME_FOR_LOCALE : 'Author Name of the LOCALE',
      DISPLAY_NAME_BLANK_REMINDER : 'Display Name cannot be blank',
      DONE : 'Done',
      DONE_EDITING : 'Finish Editing',
      DOWNLOAD : 'Download',
      EDIT : 'Edit',
      EDIT_CONTENT : 'Edit Content',
      EDIT_HOTSPOTS : 'Edit Hotspots',
      EDIT_USER : 'Edit User',
      EMAIL : 'Email',
      EMAIL_INCORRECT_REMINDER : 'Incorrect Email format',
      EMPTY_CONTENT_PROMPT : 'Are you sure not to add any content?',
      EMPTY_CONTENT_REMINDER : 'There is no content in this Hotspot, please click "+" to create',
      EMPTY_HOTSPOT_PROMPT : 'Are you sure not to add any Hotspots?',
      EMPTY_HOTSPOT_REMINDER : 'There is no Hotspot in this LOCALE, please click "New Hotspot" to add',
      EMPTY_SUBMISSION_REMINDER : "No answer has been submitted. To view students' answers here, please ask them to submit answers via their Apps",
      EMPTY_TAG_PROMPT : 'Are you sure not to add any Tags?',
      EMPTY_URL:'Video URL cannot be empty',
      EXCEED_MAX_COMPONENT : 'EXCEED_MAX_COMPONENT',
      EXCEED_MAX_HOTSPOT : 'EXCEED_MAX_HOTSPOT',
      EXIT : 'Exit',
      EXPLORE : 'Explore',
      FILE_TYPE : 'File Type',
      FILL_AT_LEAST_ONE : 'Please fill in at least one textfield',
      FILL_IN_MIND_MAP : 'Fill-in-the-Blank Mind Map',
      FILL_IN_MIND_MAP_DESCRIPTION : 'Please fill in the Mind Map',
      FILL_IN_THE_BLANK : 'Fill in the Blanks',
      FILL_IN_THE_BLANK_DESCRIPTION : 'Please fill in the blank',
      FINISH : 'Finish',
      FORGET_PASSWORD : 'Forget Password',
      HOTSPOT_INVISIBLE : 'Hotspot Invisible',
      HOTSPOT_LIST : 'Hotspot List',
      HOTSPOT_EDIT : 'Edit Hotspot Details',
      HOTSPOT_EDIT_REMINDER_1 : 'This hotspot does not have any content, and position not yet defined, are you sure to go back?',
      HOTSPOT_EDIT_REMINDER_2 : 'The position of this hotspot has not been defined, are you sure to go back?',
      HOTSPOT_EMPTY_NAME_REMINDER : 'Hotspot name cannot be blank',
      HOTSPOT_VISIBILITY : 'Hotspot Visible',
      HOTSPOT_VISIBLE : 'Normal',
      IMAGE_NOT_FILLED : 'Are you sure to leave without uploading an image?',
      IMAGE_SEARCH : 'Search Image',
      INPUT_KEYWORD : 'Input Keyword',
      KEYWORD : 'keyword',
      KLA_FULL : 'Key Learning Area',
      KLA_SHORT : 'KLA',
      LANGUAGE : 'Language',
      LAST_LOGIN_TIME : 'Last Login Time',
      LATEST_SUBMISSION : 'Latest Submission',
      LATITUDE : 'Latitude',
      LINK_OTHER_MIND_MAP_BOX : 'Link other Mind Map box',
      LOCALE_COVER_BLANK_REMINDER : 'Please upload a cover image',
      LOCALE_KLA_BLANK_REMINDER : 'Please select a KLA',
      LOCALE_MAP_BLANK_REMINDER : 'Please set a LOCALE region',
      LOCALE_MAP_MAX_SIZE_REMINDER : 'LOCALE region is too wide (length/ width bigger than 6000m)',
      LOCALE_MAP_MIN_SIZE_REMINDER : 'LOCALE region is too narrow (length/ width smaller than 1000m)',
      LOCALE_MAP_ZOOM_LV_REMINDER : 'Map Zoom Level is too small and not suitable for field study. Zoom Level greater than 15 is recommended.',
      LOCALE_NAME_BLANK_REMINDER : 'LOCALE name cannot be blank',
      LOCALE_SEARCH_RESULT_NONE : 'There is no result, please try another search',
      LOCALE_SEARCH_TEXT_PLACEHOLDER : 'Keyword or School Name',
      LOCALE_SUBJECT_BLANK_REMINDER : 'Please select a Subject',
      LOCATION : 'Location',
      LOGIN : 'Login',
      LOGOUT : 'Logout',
      LONGITUDE : 'Longitude',
      MAP_SIZE : 'Map Size (W*H)',
      MATCHVIEW_REMINDER : 'Change the size and location of the selected region to an approximated region of the current mapview',
      MC_OF_PICTURES : 'MC Question for Pictures',
      MC_OF_PICTURES_DESCRIPTION : 'Please select the most suitable picture answer',
      MC_OF_PICTURES_MULTI : 'Multiple MC Question for Pictures',
      MC_OF_PICTURES_MULTI_DESCRIPTION : 'Please select multiple picture answers',
      MC_OF_TEXTS : 'MC Question for Text',
      MC_OF_TEXTS_DESCRIPTION : 'Please select the most suitable text answer',
      MC_OF_TEXTS_MULTI : 'Multiple MC Question for Texts',
      MC_OF_TEXTS_MULTI_DESCRIPTION : 'Please select multiple text answers',
      MIND_MAP_BOX : 'Mind Map Box',
      MIND_MAP_FILL_IN_BOX : 'Filable Box',
      MIND_MAP_LABLE_BOX : 'Labelling Box',
      MOVE_DOWN : 'Move Down',
      MOVE_UP : 'Move Up',
      MOVIECLIP : 'Movie Clip',
      MOVIECLIP_URL : 'Movie Clip URL',
      MOVIECLIP_DESCRIPTION : 'Play Movie Clip',
      MY_SCHOOL : 'My School',
      NAME : 'Name',
      NEW_HOTSPOT : 'New Hotspot',
      NEW_LOCALE : 'New LOCALE',
      NEW_PASSWORD : 'New Password',
      NEXT : 'Next',
      NEXT_PAGE : 'Next Page',
      NO : 'No',
      NO_ANSWER : 'No Answer',
      NO_PHOTO : 'No Photo',
      NO_RECORDING : 'No Recording',
      NOT_POSITIONED : 'Position yet to be set',
      NO_CONTENT : 'Empty',
      NTH_FILLED : 'Content cannot be blank',
      OK : 'OK',
      OLD_PASSWORD : 'Old Password',
      OLD_PASSWORD_NOT_CORRECT : 'Incorrect Old Password',
      ONLY_SUPPORT_VIDEO: 'Only youtube videos are supported',
      OVERVIEW : 'LOCALE Overview',
      OWN_SUBMISSION: 'Own Submission',
      PAGE : 'Go To Page',
      PASSWORD : 'Password',
      PASSWORD_REQUIREMENT_0 : 'Re-entered password incorrect',
      PASSWORD_REQUIREMENT_1 : 'Illegal characters, only letters and numbers allowed',
      PASSWORD_REQUIREMENT_2 : 'Password should contain both letters and numbers',
      PASSWORD_REQUIREMENT_3 : 'Password should be longer than 6 characters',
      PASSWORD_REQUIREMENT_4 : 'Password should be shorter than 30 characters',
      PASSWORD_REQUIREMENT_5 : 'Password cannot be blank',
      PASSWORD_UPDATED : 'Password updated',
      PASSWORD_UPDATE_FAIL : 'Password update failed, please check your old password',
      PLEASE_SELECT : 'Please Select',
      POSITION : 'Position',
      POSITIONTED : 'Positioned',
      PREPARING : 'Preparing',
      PREVIOUS_PAGE : 'Previous Page',
      PROFILE : 'Profile',
      PROGRESS : 'Progress',
      PUBLIC : 'Public',
      PUBLISH : 'Publish',
      QUESTION : 'Question',
      QUESTION_DESCRIPTION : 'Text or Picture Short Question',
      QUESTION_NOT_FILLED : 'Question not filled',
      RADIUS : 'Radius',
      RE_ENTER_NEW_PASSWORD : 'Re-enter New Password',
      READY : 'Ready',
      REFRESH : 'Refresh',
      REPORT_BUG : 'Report Bug',
      REPORT_BUG_REMINDER : 'Please report bug ',
      RETRIEVE_ANSWERS : 'Review answers',
      ROW : 'Row',
      ROW_COL_NOT_FILLED : 'Row/column cannot be blank',
      SAFE_IMAGE_SEARCH : 'Safe Image Search',
      SAVE : 'Save',
      SCHOOL : 'School',
      SCHOOL_LIST : 'School List',
      SCHOOL_NAME : 'School Name',
      SEARCH : 'Search',
      SEARCH_LOCATION : 'Search Location',
      SELECT : 'Select',
      SELECT_IMAGE : 'Select Image',
      SET_POSITION : 'Set Position',
      SETTINGS : 'Settings',
      SHARABLE : 'Sharable',
      SHARE:'Share',
      SIMPLE_DESCRIPTION : 'Photo Description',
      SIMPLE_DESCRIPTION_DESCRIPTION : 'Simple Photo Description',
      SORT_BY : 'Sort By',
      SORT_CREATE_DATE_ASC : 'Created (Earliest)',
      SORT_CREATE_DATE_DESC : 'Created (Latest)',
      SORT_MODIFY_DATE_ASC : 'Modified (Earliest)',
      SORT_MODIFY_DATE_DESC : 'Modified (Latest)',
      SORT_NAME_ASC : 'Name (A-Z)',
      SORT_DOWNLOAD_COUNT_ASC : 'Least Downloaded',
      SORT_DOWNLOAD_COUNT_DESC : 'Most Downloaded',
      STORAGE : 'Storage',
      SUBJECT : 'Subject',
      SUBMISSION_DATE : 'Submission Date',
      SUBMISSION_P : 'Submitted People',
      SUBMISSION_S : 'Submission(s)',
      SUBMISSION_TIME : 'Submission Time',
      SUBMIT : 'Submit',
      SUBMITTED : 'Submitted',
      SWITCH_BACK_TO_CLASSIC_UI : 'Classic User Interface',
      SWITCH_TO_LIST : 'Switch to List',
      SWITCH_TO_MAP : 'Switch to Map',
      TABLE_AND_CELL : 'Add Table ',
      TABLE_AND_CELL_DESCRIPTION : 'Add Question to Table/ Add Statistical Question',
      TAKE_PHOTO : 'Photo-taking Question',
      TAKE_PHOTO_DESCRIPTION : 'Request to Take Photo/ Draw',
      TAKE_RECORD : 'Recording/ Interviewing',
      TAKE_RECORD_DESCRIPTION : 'Request to Record',
      TELEPORT : 'View Location of Hotspot',
      TELEPORT_REMINDER : 'If the selected region is out of the mapview, move the mapview to the selected region',
      TIME : 'Time',
      TITLE : 'Title',
      TOO_NARROW_REMINDER : 'Distance is too short',
      TOO_WIDE_REMINDER : 'Distance is too long',
      UNSPECIFIED_SUBJECT : 'Unspecified Subject',
      UNSAVED_CHANGES : 'Changes Unsaved',
      UNSAVED_REMINDER : 'Are you sure not to save changes?',
      UPDATE : 'Update',
      UPDATE_FAILED : 'Update Failed',
      UPDATE_PASSWORD : 'Update Password',
      UPDATE_PROFILE : 'Update Profile',
      UPDATED : 'Updated',
      UPLOAD : 'Upload',
      UPLOAD_COMPLETE : 'Upload Completed',
      UPLOAD_FAILED : 'Upload Failed',
      UPLOAD_FILE_SIZE_REMINDER : 'File Size must be less than',
      UPLOAD_FILE_TYPE_REMINDER : 'File Type not allowed',
      UPLOAD_FILE : 'Upload File',
      UPLOAD_LOCAL_FILE : 'Upload Local File',
      UPLOAD_SCREENSHOT : 'Upload Screenshot',
      UPLOADED : 'Uploaded',
      UPLOADING : 'Uploading',
      USER_INFORMATION : 'User Information',
      USER_LIST : 'User List',
      USERNAME : 'Username',
      VIEW_EDIT_DETAILS : 'View/ Edit Details',
      VOICE_NOT_FILLED : 'MP3 file not yet uploaded ',
      VOICE_OVER : 'Voice Over',
      VOICE_OVER_DESCRIPTION : 'Play MP3 file',
      YES : 'Yes',
      YOUTUBE_ID_INVALID:'The Video URL is invalid',
      YOUTUBE_URL_TOO_LONG:'Video URL is too long',
      ZOOM : 'Zoom',
      ZOOM_IN : 'Zoom In',
      ZOOM_OUT : 'Zoom Out',
      LOCALE_LIST : 'LOCALE List',
      EMAIL_CAN_BE_USED_AS_LOGIN : 'Email can be used as login and retrival of password',
      SUBMIT_BUG_REPORT : 'Bug report will be submitted via Google Form, are you sure to open another webpage and submit the report?',
      PUBLIC_LOCALE_ONLY : 'Public LOCALE Only',
      QA_STATE : 'Audit Status',
      QA_STATE_ANY : 'All',
      QA_STATE_UNCHECKED : 'Not Yet Audited',
      QA_STATE_CHECKED : 'Audited',
      QA_STATE_MINOR : 'Minor Issue',
      QA_STATE_MAJOR : 'Major Issue',
      RETRIEVER : 'RETRIEVER Answer Viewing',
      DROP_FILE_HERE_OR_CLICK_TO_SELECT : 'Click to select file, or drag and drop a file here',
      UPDATED_DATE : 'Updated Time',
      CREATED_DATE : 'Created Time',
      MOVE_TO_HOTSPOT_LOCATION : 'Move to Hotspot Location',
      MOVE_TO_HOTSPOT_LOCATION_REMINDER : 'Mapview will move to Hotspot Location',
      HOTSPOT_HAS_LOCATION : 'Hotspot Location is set',
      METER : 'M',
      REVEAL_CODE: "Reveal Code",
      REVEAL_CODE_REQUIREMENT_0: "Illegal characters, only letters and numbers allowed",
      REVEAL_CODE_REQUIREMENT_1: "Reveal Code should contain both letters and numbers",
      REVEAL_CODE_REQUIREMENT_2: "Reveal Code must contain 6 characters",
      REVEAL_CODE_REQUIREMENT_3: "Reveal Code cannot be blank",
      USE_REVEAL_CODE: "Use hotspots reveal Code",
      ENABLE_REVEAL_CODE: "Enable reveal code",
      ENABLE_REVEAL_CODE_MESSAGE: "Reveal all hotspots by entering the code in EduVenture X app.",
      DISABLE_REVEAL_CODE_MESSAGE: "Cannot reveal all hotspots in EduVenture X app.",
      NEW_APP_VERSION_REQUIRED: "This locale can be viewed only in EduVenture X app after v1.5.0.",
    },

    tc:{

      ACCEPT : '接受',
      ACCOUNT_SETTINGS : '帳戶設定',
      ADD_CONTENT : '新增內容',
      ADD_MIND_MAP_FILL_IN_BOX : '新增填充方塊',
      ADD_MIND_MAP_LABLE_BOX : '新增描述方塊',
      ADMIN_TASK : '管理員職務',
      ALL_SCHOOLS : '所有學校',
      ALL_USERS : '所有用戶',
      ARCHIVE:'匯出到Excel',
      ANSWER : '答案',
      ANSWER_NOT_ALL_FILLED : '請為答案提供最少4個圖片檔案',
      AUTHOR : '作者',
      BACK : '上一步',
      CANCEL : '取消',
      CATEGORY : '類別',
      CATEGORY_CREATION : '創作',
      CATEGORY_EXPERIENCE : '體驗',
      CATEGORY_EXPERIMENT : '實驗',
      CATEGORY_EXPLORATION : '探究',
      CATEGORY_NONE : '沒分類',
      CATEGORY_KNOWLEDGE : '知識',
      CHANGE : '更改',
      CHANGE_PASSWORD : '更改密碼',
      CHOICE : '選擇',
      CLEAR : '清除',
      CLOSE : '關閉',
      COLOR : '顏色',
      COLUMN : '欄',
      COMPARE_ANSWERS : '比較答案',
      CONTENT : '內容',
      CONTENT_NAME : '內容名稱',
      CONTENT_PHOTO_FILE_INSTRUCTION : '如需描述多於1張圖片，可創建多個圖文描述。\n 圖片不是必須的，但建議使用，以增加學習動機。 \n 每個圖文描述上限為2000字。',
      CONTENT_TYPE : '內容種類',
      CONTINUE_EDITING : '繼續編輯',
      CORRECT : '正確',
      CORRECT_ANSWER : '答案正確',
      CORRECT_ANSWER_CONTECT_NOT_FILLED : '請填寫正確答案',
      CORRECT_ANSWER_NOT_SELECTED : '請選擇最少一個正確答案',
      COVER_IMAGE : '封面圖片',
      CREATE : '建立',
      CREATE_SCHOOL : '建立學校',
      CREATE_USER : '建立用戶',
      CREATED : '已建立',
      DARK_MODE : '深色模式',
      DECLINE : '拒絕',
      DELETE : '刪除',
      DELETE_CONTENT : '刪除內容',
      DELETE_FAILED : '刪除失敗',
      DELETE_FILE : '刪除檔案',
      DELETE_HOTSPOT : '刪除熱點',
      DELETE_LOCALE : '刪除考察教件',
      DELETE_MIND_MAP_BOX : '刪除方塊',
      DELETE_MIND_MAP_LINK : '移除連結',
      DELETE_REMINDER : '刪除後將不能復原，請確定是否刪除所選項目？',
      DELETED : '所選項目已被刪除',
      DESCRIPTION : '描述',
      DESCRIPTION_AUDIO : '聲音描述',
      DESCRIPTION_FILL_IN_THE_BLANK_AFTER : '填充部分後的文字',
      DESCRIPTION_FILL_IN_THE_BLANK_BEFORE : '填充部分前的文字',
      DESCRIPTION_IMAGE : '描述圖片',
      DESCRIPTION_NOT_FILLED : '請填寫文字描述',
      DESCRIPTION_QUESTION : '問題',
      DESCRIPTION_TAKE_PHOTO : '拍攝題描述',
      DESCRIPTION_TAKE_RECORD : '錄音指示',
      DESCRIPTION_TEXT : '文字描述',
      DESCRIPTION_VIDEO : '影片描述',
      DETAILS : '細節',
      DIFFICULTY : '難度',
      DISCARD : '放棄',
      DISCARD_CHANGES : '放棄更改',
      DISPLAY_NAME : '顯示名稱',
      DISPLAY_NAME_FOR_LOCALE : '考察教件創作者名稱',
      DISPLAY_NAME_BLANK_REMINDER : '顯示名稱不能空白',
      DONE : '完成',
      DONE_EDITING : '完成編輯',
      DOWNLOAD : '下載',
      EDIT : '編輯',
      EDIT_CONTENT : '編輯內容',
      EDIT_HOTSPOTS : '編輯熱點',
      EDIT_USER : '編輯用戶',
      EMAIL : '電郵',
      EMAIL_INCORRECT_REMINDER : '電郵格式不正確',
      EMPTY_CONTENT_PROMPT : '確定不填寫內容嗎？',
      EMPTY_CONTENT_REMINDER : '這熱點未有內容，請按「＋」來創建',
      EMPTY_HOTSPOT_PROMPT : '確定不增加熱點嗎？',
      EMPTY_HOTSPOT_REMINDER : '這考察教件未有熱點，請按「新的熱點」來創建',
      EMPTY_SUBMISSION_REMINDER : '這考察教件未有人提交答案。請要求學生於應用程式裏遞交答案，然後在此檢閱',
      EMPTY_TAG_PROMPT : '確定不增加標籤嗎？',
      EMPTY_URL:'影片網站輸入欄不能為空白',
      EXCEED_MAX_COMPONENT : 'EXCEED_MAX_COMPONENT',
      EXCEED_MAX_HOTSPOT : 'EXCEED_MAX_HOTSPOT',
      EXIT : '離開',
      EXPLORE : '探索',
      FILE_TYPE : '檔案類型',
      FILL_AT_LEAST_ONE : '請填寫最少一個文字框',
      FILL_IN_MIND_MAP : '概念圖填充題',
      FILL_IN_MIND_MAP_DESCRIPTION : '請填寫概念圖',
      FILL_IN_THE_BLANK : '填充',
      FILL_IN_THE_BLANK_DESCRIPTION : '請填上合適的答案',
      FINISH : '完成',
      FORGET_PASSWORD : '忘記密碼',
      HOTSPOT_INVISIBLE : '隱藏熱點',
      HOTSPOT_LIST : '熱點列表',
      HOTSPOT_EDIT : '編輯熱點內容',
      HOTSPOT_EDIT_REMINDER_1 : '本熱點的位置及內容尚未設定，確定離開嗎？',
      HOTSPOT_EDIT_REMINDER_2 : '本熱點的位置尚未設定，確定離開嗎？',
      HOTSPOT_EMPTY_NAME_REMINDER : '熱點名字不能為空白',
      HOTSPOT_VISIBILITY : '顯示熱點',
      HOTSPOT_VISIBLE : '正常顯示',
      IMAGE_NOT_FILLED : '未上傳圖片，確定離開嗎？',
      IMAGE_SEARCH : '搜尋圖片',
      INPUT_KEYWORD : '輸入關鍵字',
      KEYWORD : '關鍵字',
      KLA_FULL : '學習領域 KLA',
      KLA_SHORT : '學習領域',
      LANGUAGE : '語言',
      LAST_LOGIN_TIME : '上次登入時間',
      LATEST_SUBMISSION : '最近提交',
      LATITUDE : '緯度',
      LINK_OTHER_MIND_MAP_BOX : '連結其他概念圖方塊',
      LOCALE_COVER_BLANK_REMINDER : '請上載一張封面圖片',
      LOCALE_KLA_BLANK_REMINDER : '請選擇一個學習領域',
      LOCALE_MAP_BLANK_REMINDER : '請設定考察範圍',
      LOCALE_MAP_MAX_SIZE_REMINDER : '考察範圍太廣（長／寬大於六千米）',
      LOCALE_MAP_MIN_SIZE_REMINDER : '考察範圍太窄（長／寬小於一千米）',
      LOCALE_MAP_ZOOM_LV_REMINDER : '地圖縮放度太小，不適合考察，建議設為大於15',
      LOCALE_NAME_BLANK_REMINDER : '名稱不能為空白',
      LOCALE_SEARCH_RESULT_NONE : '未有符合條件的考察教件，請嘗試以其他條件搜尋',
      LOCALE_SEARCH_TEXT_PLACEHOLDER : '關鍵字或學校名稱',
      LOCALE_SUBJECT_BLANK_REMINDER : '請選擇一個學科',
      LOCATION : '地點',
      LOGIN : '登入',
      LOGOUT : '登出',
      LONGITUDE : '經度',
      MAP_SIZE : '地圖大小 (闊*高)',
      MATCHVIEW_REMINDER : '把考察範圍設定成與當前地圖視窗大致相似的區域',
      MC_OF_PICTURES : '圖片選擇題',
      MC_OF_PICTURES_DESCRIPTION : '請選擇最合適的圖片答案',
      MC_OF_PICTURES_MULTI : '圖片多項選擇題',
      MC_OF_PICTURES_MULTI_DESCRIPTION : '請選擇多個圖片答案',
      MC_OF_TEXTS : '文字選擇題',
      MC_OF_TEXTS_DESCRIPTION : '請選擇最合適的文字答案',
      MC_OF_TEXTS_MULTI : '文字多項選擇題',
      MC_OF_TEXTS_MULTI_DESCRIPTION : '請選擇多個文字答案',
      MIND_MAP_BOX : '方塊',
      MIND_MAP_FILL_IN_BOX : '填充方塊',
      MIND_MAP_LABLE_BOX : '描述方塊',
      MOVE_DOWN : '向下移',
      MOVE_UP : '向上移',
      MOVIECLIP : '短片',
      MOVIECLIP_DESCRIPTION : '播放短片',
      MY_SCHOOL : '我的學校',
      NAME : '名稱',
      NEW_HOTSPOT : '新熱點',
      NEW_LOCALE : '新考察教件',
      NEW_PASSWORD : '新密碼',
      NEXT : '下一步',
      NEXT_PAGE : '下一頁',
      NO : '否',
      NO_ANSWER : '未有答案',
      NO_PHOTO : '未有拍攝',
      NO_RECORDING : '未錄音',
      NOT_POSITIONED : '未設定位置',
      NO_CONTENT : '沒內容',
      NTH_FILLED : '未填寫任何內容',
      OK : '好',
      OLD_PASSWORD : '舊密碼',
      OLD_PASSWORD_NOT_CORRECT : '舊密碼不正確',
      ONLY_SUPPORT_VIDEO:'請輸入有效的Youtube影片網址',
      OVERVIEW : '考察教件概覽',
      OWN_SUBMISSION: '檢查已提交答案的教件',
      PAGE : '跳至頁數',
      PASSWORD : '密碼',
      PASSWORD_REQUIREMENT_0 : '重新輸入的密碼不正確',
      PASSWORD_REQUIREMENT_1 : '字元無效，只可使用字母和數字',
      PASSWORD_REQUIREMENT_2 : '密碼只可包含字母和數字',
      PASSWORD_REQUIREMENT_3 : '密碼長度須超過6個字元',
      PASSWORD_REQUIREMENT_4 : '密碼長度不可超過30個字元',
      PASSWORD_REQUIREMENT_5 : '密碼不能為空白',
      PASSWORD_UPDATED : '密碼已更新',
      PASSWORD_UPDATE_FAIL : '密碼更新失敗，請檢查你的舊密碼',
      PLEASE_SELECT : '請選擇',
      POSITION : '位置',
      POSITIONTED : '已選定位置',
      PREPARING : '準備中',
      PREVIOUS_PAGE : '上一頁',
      PROFILE : '個人資料',
      PROGRESS : '進度',
      PUBLIC : '公開',
      PUBLISH : '發布',
      QUESTION : '問題',
      QUESTION_DESCRIPTION : '文字或圖片短答問題',
      QUESTION_NOT_FILLED : '未填寫問題',
      RADIUS : '半徑',
      RE_ENTER_NEW_PASSWORD : '再次輸入新密碼',
      READY : '就緒',
      REFRESH : '刷新',
      REPORT_BUG : '匯報漏洞',
      REPORT_BUG_REMINDER : '請匯報漏洞',
      RETRIEVE_ANSWERS : '查看答案',
      ROW : '行',
      ROW_COL_NOT_FILLED : '未填寫行／欄名稱',
      SAFE_IMAGE_SEARCH : '安全搜尋圖片',
      SAVE : '儲存',
      SCHOOL : '學校',
      SCHOOL_LIST : '學校列表',
      SCHOOL_NAME : '學校名稱',
      SEARCH : '搜尋',
      SEARCH_LOCATION : '搜尋地方',
      SELECT : '選擇',
      SELECT_IMAGE : '選擇圖片',
      SET_POSITION : '設定位置',
      SETTINGS : '設定',
      SHARABLE : '共享',
      SHARE:'分享',
      SIMPLE_DESCRIPTION : '圖文描述',
      SIMPLE_DESCRIPTION_DESCRIPTION : '簡單圖文描述',
      SORT_BY : '排序',
      SORT_CREATE_DATE_ASC : '由最早建立',
      SORT_CREATE_DATE_DESC : '由最近建立',
      SORT_MODIFY_DATE_ASC : '由最早更新',
      SORT_MODIFY_DATE_DESC : '由最近更新',
      SORT_NAME_ASC : '名稱 (A-Z)',
      SORT_DOWNLOAD_COUNT_ASC : '最少下載次數',
      SORT_DOWNLOAD_COUNT_DESC : '最多下載次數',
      STORAGE : '儲存空間',
      SUBJECT : '學科',
      SUBMISSION_DATE : '提交日期',
      SUBMISSION_P : '提交人數',
      SUBMISSION_S : '提交數量',
      SUBMISSION_TIME : '提交時間',
      SUBMIT : '提交',
      SUBMITTED : '已提交',
      SWITCH_BACK_TO_CLASSIC_UI : '經典用戶界面',
      SWITCH_TO_LIST : '切換至列表',
      SWITCH_TO_MAP : '切換至地圖',
      TABLE_AND_CELL : '新增表格',
      TABLE_AND_CELL_DESCRIPTION : '新增表格題目 / 統計題目',
      TAKE_PHOTO : '拍照題',
      TAKE_PHOTO_DESCRIPTION : '要求拍攝或繪畫',
      TAKE_RECORD : '錄音 / 訪問',
      TAKE_RECORD_DESCRIPTION : '要求錄音',
      TELEPORT : '檢視熱點位置',
      TELEPORT_REMINDER : '若考察範圍在地圖視窗外，把地圖視窗移動至考察範圍',
      TIME : '時間',
      TITLE : '標題',
      TOO_NARROW_REMINDER : '距離太短',
      TOO_WIDE_REMINDER : '距離太長',
      UNSPECIFIED_SUBJECT : '沒特定科目',
      UNSAVED_CHANGES : '未儲存變更',
      UNSAVED_REMINDER : '確定不儲存變更嗎？',
      UPDATE : '更新',
      UPDATE_FAILED : '更新失敗',
      UPDATE_PASSWORD : '更新密碼',
      UPDATE_PROFILE : '更新個人資料',
      UPDATED : '已更新',
      UPLOAD : '上載',
      UPLOAD_COMPLETE : '上載完成',
      UPLOAD_FAILED : '上載失敗',
      UPLOAD_FILE_SIZE_REMINDER : '檔案大小須小於',
      UPLOAD_FILE_TYPE_REMINDER : '不允許的檔案類型',
      UPLOAD_FILE : '上載檔案',
      UPLOAD_LOCAL_FILE : '上載本機檔案',
      UPLOAD_SCREENSHOT : '上載截圖',
      UPLOADED : '已上載',
      UPLOADING : '上載中',
      USER_INFORMATION : '用戶資料',
      USER_LIST : '用戶列表',
      USERNAME : '用戶名稱',
      VIEW_EDIT_DETAILS : '查看 / 編輯細節',
      VOICE_NOT_FILLED : '未上傳MP3音檔',
      VOICE_OVER : '聲音導航',
      VOICE_OVER_DESCRIPTION : '播放MP3音檔',
      YES : '是',
      YOUTUBE_ID_INVALID:'無效的Youtube網站',
      YOUTUBE_URL_TOO_LONG:'影片網址太長',
      ZOOM : '縮放',
      ZOOM_IN : '放大',
      ZOOM_OUT : '縮小',
      LOCALE_LIST : '考察教件列表',
      EMAIL_CAN_BE_USED_AS_LOGIN : '電郵可以用作登入名稱及找回密碼',
      SUBMIT_BUG_REPORT : '問題報告將會由Google Form收集，確定開啟另一個網頁並提交問題報告？',
      PUBLIC_LOCALE_ONLY : '只檢閱公開考察教件',
      QA_STATE : '審檢狀態',
      QA_STATE_ANY : '所有',
      QA_STATE_UNCHECKED : '未審檢',
      QA_STATE_CHECKED : '已審檢',
      QA_STATE_MINOR : '小問題',
      QA_STATE_MAJOR : '大問題',
      RETRIEVER : 'RETRIEVER 收集答案工具',
      DROP_FILE_HERE_OR_CLICK_TO_SELECT : '按這裡選擇檔案，或把檔案拖放到這裡',
      UPDATED_DATE : '更新時間',
      CREATED_DATE : '創建時間',
      MOVE_TO_HOTSPOT_LOCATION : '移至熱點位置',
      MOVE_TO_HOTSPOT_LOCATION_REMINDER : '地圖視窗會跳到熱點所在位置',
      HOTSPOT_HAS_LOCATION : '已設好熱點位置',
      METER : '米',
      MOVIECLIP_URL : '影片網站',
      REVEAL_CODE: "解鎖代碼",
      REVEAL_CODE_REQUIREMENT_0: "字元無效，只可使用字母和數字",
      REVEAL_CODE_REQUIREMENT_1: "代碼只可包含字母和數字",
      REVEAL_CODE_REQUIREMENT_2: "代碼必須包含6個字元",
      REVEAL_CODE_REQUIREMENT_3: "代碼不能為空白",
      USE_REVEAL_CODE: "使用熱點解鎖代碼",
      ENABLE_REVEAL_CODE: "啟用解鎖代碼",
      ENABLE_REVEAL_CODE_MESSAGE: "在EduVenture X應用程序中輸入代碼來解鎖所有熱點。",
      DISABLE_REVEAL_CODE_MESSAGE: "不能在EduVenture X應用程序中輸入代碼來解鎖所有熱點。",
      NEW_APP_VERSION_REQUIRED: "此教件只能在 v1.5.0 或更新的EduVenture X應用程式版本開啟。",
    },

  })

}



export default Localization;

